import React, { Component } from 'react';
import _ from 'underscore';

export default class HashPropertyForm extends Component {
  constructor(props) {
    super(props);

    this.state = Object.assign(props.property, {
      errors: props.errors,
      enabled: props.enabled,
    });
    this.state.template_input = props.property.template_name !== '';
  }

  updateState(obj) {
    if (typeof obj.template_name !== 'undefined') {
      obj.template_input = true;
    }
    if (typeof obj.name !== 'undefined') {
      obj = this.handleNameChange(obj);
    }
    this.props.onChange(Object.assign({}, this.state, obj));
  }

  handleNameChange(obj) {
    if (this.state.template_input || obj.template_input) {
      return obj;
    }
    obj.template_name = 'my_' + obj.name.toLowerCase().replace(/ /g, '_');

    return obj;
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(Object.assign(props.property, { enabled: props.enabled }));
  }

  errorsFor(attr) {
    if (typeof this.state.errors[attr] === 'undefined') {
      return [];
    }
    return _.uniq(this.state.errors[attr]);
  }

  renderErrorsFor(attr) {
    return this.errorsFor(attr).map((errorMessage, index) => {
      return (
        <div
          key={`${attr}${index}`}
          className='ui alert message'
        >
          {errorMessage}
        </div>
      );
    });
  }

  render() {
    return (
      <div className='ui form'>
        <h4 className='ui header'>Property</h4>
        <div className='field'>
          <label>Name</label>
          <input
            disabled={!this.state.enabled}
            type='text'
            value={this.state.name}
            onChange={(e) => this.updateState({ name: e.target.value })}
          />
          {this.renderErrorsFor('name')}
        </div>
        <div className='field'>
          <label>Template Name</label>
          <input
            disabled={!this.state.enabled}
            type='text'
            value={this.state.template_name}
            onChange={(e) =>
              this.updateState({ template_name: e.target.value })
            }
          />
          {this.renderErrorsFor('template_name')}
        </div>
        <div className='field'>
          <label>Description</label>
          <textarea
            disabled={!this.state.enabled}
            value={this.state.description}
            onChange={(e) => this.updateState({ description: e.target.value })}
          />
          {this.renderErrorsFor('description')}
        </div>
        <div className='grouped fields'>
          <label>Applies To</label>

          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.applies_to_node}
                disabled={!this.state.enabled}
                id='scope_node'
                type='checkbox'
                onChange={(e) =>
                  this.updateState({ applies_to_node: e.target.checked })
                }
              />
              <label htmlFor='scope_node'>Node</label>
            </div>
          </div>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.applies_to_server}
                disabled={!this.state.enabled}
                id='scope_server'
                type='checkbox'
                onChange={(e) =>
                  this.updateState({ applies_to_server: e.target.checked })
                }
              />
              <label htmlFor='scope_server'>Server</label>
            </div>
          </div>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.applies_to_node_group}
                disabled={!this.state.enabled}
                id='scope_group'
                type='checkbox'
                onChange={(e) =>
                  this.updateState({ applies_to_node_group: e.target.checked })
                }
              />
              <label htmlFor='scope_group'>Node Group</label>
            </div>
          </div>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.applies_to_customer}
                disabled={!this.state.enabled}
                id='scope_customer'
                type='checkbox'
                onChange={(e) =>
                  this.updateState({ applies_to_customer: e.target.checked })
                }
              />
              <label htmlFor='scope_customer'>Site</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
